__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "billing-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@matillion/component-library", "26.0.2", () => (Promise.all([__webpack_require__.e(806), __webpack_require__.e(289), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(380)]).then(() => (() => (__webpack_require__(88289))))));
			register("@matillion/hex-react", "0.113.2", () => (Promise.all([__webpack_require__.e(68), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(184)]).then(() => (() => (__webpack_require__(5068))))));
			register("@matillion/hub-client", "14.21.1", () => (Promise.all([__webpack_require__.e(759), __webpack_require__.e(210), __webpack_require__.e(829), __webpack_require__.e(525)]).then(() => (() => (__webpack_require__(25210))))));
			register("@matillion/micro-client", "1.1.0", () => (Promise.all([__webpack_require__.e(829), __webpack_require__.e(162)]).then(() => (() => (__webpack_require__(96162))))));
			register("@matillion/micro-router", "2.3.0", () => (Promise.all([__webpack_require__.e(566), __webpack_require__.e(829), __webpack_require__.e(329)]).then(() => (() => (__webpack_require__(13566))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(829)]).then(() => (() => (__webpack_require__(54164))))));
			register("react-router-dom", "7.18.4", () => (Promise.all([__webpack_require__.e(957), __webpack_require__.e(829), __webpack_require__.e(272)]).then(() => (() => (__webpack_require__(90957))))));
			register("react", "18.3.1", () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(72791))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};